import { createSelector } from 'reselect';
import { calculateM2CO2, calculateLinearMeterCO2, calculateStandardCO2 } from '../../../../../Utils/co2Calculator';

// Remove Flow type annotation for JavaScript file
const selectEstimate = state => state.screens.EstimateView.estimate;

export default createSelector(
  selectEstimate,
  (estimate) => {

    const estimateTotals = {
      subtotal: 0,
      discount: 0,
      total: 0,
      co2Total: 0
    }

    if (estimate) {

      estimate.estimate_groups.forEach((estimateGroup) => estimateGroup.estimate_items
        .filter((estimateItem) => estimateItem.flag !== 'Omit' && estimateItem.flag !== 'By Others')
        .forEach((estimateItem) => {

          estimateTotals.subtotal += Number(estimateItem.subtotal);
          estimateTotals.discount += Number(estimateItem.discount);
          estimateTotals.total += Number(estimateItem.total);
          
          // Only use the stored co2 value if it exists, otherwise calculate it
          if (estimateItem.co2 && !isNaN(parseFloat(estimateItem.co2))) {
            // Use the pre-calculated CO2 value stored in the item
            estimateTotals.co2Total += parseFloat(estimateItem.co2);
          } 
          // If no co2 value exists but we have paint data or coverage data, calculate it
          else if (estimateItem.type === 'D' && estimateItem.quantity && 
              ((estimateItem.unit === 'm2' && estimateItem.paint_data) ||
               (estimateItem.unit === 'm' && estimateItem.coverage_data))) {
            try {
              let coverage = 0;
              let carbon = 0;
              let coats = 1;
              const quantity = parseFloat(estimateItem.quantity || 0);
              
              // Handle different data sources based on unit type
              if (estimateItem.unit === 'm2' && estimateItem.paint_data) {
                // Parse the paint data JSON for m2 unit
                const paintData = JSON.parse(estimateItem.paint_data);
                console.log('Paint data in footer selector for m2:', paintData);
                
                carbon = parseFloat(paintData.carbon || paintData.Carbon || 0);
                coats = parseFloat(paintData.coats || paintData.Coats || 1); // Default to 1 coat if not specified
                
                // If we still don't have carbon value, try alternative property names
                if (carbon === 0) carbon = parseFloat(paintData['Carbon (m2 PL)'] || 0);
                
                // Calculate CO2 for m2 using centralized function
                const co2Used = calculateM2CO2(quantity, carbon, coats);
                estimateTotals.co2Total += co2Used;
                
                // Skip the regular calculation below
                coverage = 0;
              }
              else if (estimateItem.unit === 'm' && estimateItem.coverage_data) {
                // Parse the coverage data JSON for m unit
                const coverageData = JSON.parse(estimateItem.coverage_data);
                console.log('Coverage data in footer selector for linear meters:', coverageData);
                
                // Get coverage, carbon, coats, and paint coverage values from coverage data
                coverage = parseFloat(coverageData.coverage || 0);
                carbon = parseFloat(coverageData.carbon || 0);
                coats = parseFloat(coverageData.coats || 1); // Default to 1 coat if not specified
                const paintCoverage = parseFloat(coverageData.paint_coverage || 1); // Default to 1 if not specified
                
                console.log(`Footer CO2 calc for linear meters - Coverage: ${coverage}, Paint Coverage: ${paintCoverage}, Carbon: ${carbon}, Coats: ${coats}, Quantity: ${quantity}`);
                
                // Calculate CO2 for linear meters using centralized function
                const co2Used = calculateLinearMeterCO2(quantity, coverage, paintCoverage, carbon, coats);
                estimateTotals.co2Total += co2Used;
                
                // Set coverage to 0 to skip the regular calculation below
                coverage = 0;
              }
              
              // Calculate CO2 used for standard calculations
              if (coverage > 0 && carbon > 0) {
                const co2Used = calculateStandardCO2(quantity, coverage, carbon, coats);
                estimateTotals.co2Total += co2Used;
              }
            } catch (e) {
              // Ignore errors in CO2 calculation
              console.error('Error calculating CO2:', e);
            }
          }

        })
      );

    }

    return estimateTotals;

  }
)